import { FontFamily } from "../FontFamily";
import type { ITextStyle } from "@pixi/text";

export const DefaultTextStyle: Partial<ITextStyle> = {
  fontFamily: FontFamily.Default,
  fontSize: 26,
  lineHeight: 32,
  fill: 0xffffff,
};
